// src/components/Header/Header.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import Button from "../button/Button";
import logo from "../../assets/images/logo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const toggleMenu = () => setIsOpen(!isOpen);
  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Service", path: "/service" },
    { name: "Contact", path: "/contact" },
    { name: "Blog", path: "/blog" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/90 shadow-sm shadow-slate-900/5 backdrop-blur-xl transition-all duration-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Bagian utama header */}
        <div className="flex min-h-[68px] items-center justify-between gap-4 py-2.5">
          {/* Logo */}
          <Link
            to="/"
            className="flex flex-shrink-0 items-center rounded-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-blue-100"
          >
            <img
              src={logo}
              alt="Tomi Logo"
              className="h-8 w-auto sm:h-9 md:h-10"
            />
          </Link>

          {/* Menu Desktop */}
          <div className="hidden flex-1 items-center justify-center lg:flex">
            <nav className="flex items-center gap-1 rounded-2xl border border-slate-200 bg-slate-50/80 p-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-link-animated ${
                    isActive(item.path)
                      ? "is-active text-[#2458d3]"
                      : "text-slate-600"
                  }`}
                >
                  <span className="nav-link-label">{item.name}</span>
                </Link>
              ))}
            </nav>
          </div>
          {/* Ikon Sosial + Tombol */}
          <div className="hidden items-center gap-3 lg:flex">
            <div className="flex items-center gap-1.5">
              <a
                href="https://www.instagram.com/tokomikro.id/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#eef4ff] hover:text-[#3f6fe5] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#c9d8ff]"
              >
                <FaInstagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61575624527998"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#eef4ff] hover:text-[#3f6fe5] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#c9d8ff]"
              >
                <FaFacebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.tiktok.com/@tokomikro.id?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#eef4ff] hover:text-[#3f6fe5] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#c9d8ff]"
              >
                <FaTiktok className="h-5 w-5" />
              </a>
            </div>
            <a
              href={`${process.env.REACT_APP_API_URL}/download/aplikasi/tomi-101.apk`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <Button variant="primary" className="whitespace-nowrap px-4 py-2 text-sm xl:px-5 xl:py-2.5">
                Download Sekarang
              </Button>
            </a>
          </div>

          {/* Tombol Menu Mobile */}
          <div className="flex lg:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-700 transition-all duration-300 hover:bg-[#eef4ff] hover:text-[#2458d3] focus:outline-none focus:ring-4 focus:ring-[#c9d8ff]"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <FaTimes className="h-5 w-5" />
              ) : (
                <FaBars className="h-5 w-5" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Menu Mobile */}
      <div
        className={`overflow-hidden border-t border-slate-100 bg-white/95 shadow-xl shadow-slate-900/10 backdrop-blur-xl transition-all duration-300 lg:hidden ${
          isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="mx-auto flex max-w-7xl flex-col gap-1.5 px-5 py-4 sm:px-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={`block rounded-xl px-4 py-2.5 text-sm font-semibold transition-all duration-300 hover:translate-x-1 sm:text-base ${
                isActive(item.path)
                  ? "bg-[#eef4ff] text-[#2458d3] ring-1 ring-[#c9d8ff]"
                  : "text-slate-700 hover:bg-slate-50 hover:text-[#2458d3]"
              }`}
            >
              {item.name}
            </Link>
          ))}

          {/* Tombol Mobile */}
          <div className="pt-2">
            <Button
              variant="primary"
              className="w-full py-2.5 text-sm sm:text-base"
              onClick={() => setIsOpen(false)}
            >
              Download Sekarang
            </Button>
          </div>

          {/* Ikon Sosial di bawah menu mobile */}
          <div className="flex items-center justify-center gap-3 border-t border-slate-100 pt-4">
            <a
              href="https://www.instagram.com/tomiindonesia"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 text-slate-600 transition-all duration-300 hover:bg-[#eef4ff] hover:text-[#3f6fe5]"
            >
              <FaInstagram className="h-5 w-5" />
            </a>
            <a
              href="https://www.facebook.com/tomiindonesia"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 text-slate-600 transition-all duration-300 hover:bg-[#eef4ff] hover:text-[#3f6fe5]"
            >
              <FaFacebook className="h-5 w-5" />
            </a>
            <a
              href="https://www.tiktok.com/@tomiindonesia"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 text-slate-600 transition-all duration-300 hover:bg-[#eef4ff] hover:text-[#3f6fe5]"
            >
              <FaTiktok className="h-5 w-5" />
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
